export const FILTER_TYPES = {
  SELECT: "select",
  RANGE: "range",
  DATE: "date",
};
